/**
 * Install-prompt moment: captured beforeinstallprompt is offered once, at
 * the first mitosis (peak delight). iOS has no prompt API — it gets a
 * one-time pictorial hint instead.
 */
interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
}

const OFFERED_KEY = 'tg.installOffered';

let deferred: BeforeInstallPromptEvent | null = null;

export function watchInstallPrompt(): void {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferred = e as BeforeInstallPromptEvent;
  });
}

/** Returns what to show: a native prompt trigger, an iOS hint, or nothing. */
export function offerInstallOnce(
  showToastFn: (text: string, actionLabel?: string, onAction?: () => void) => void,
  keepUsText: string,
  installLabel: string,
  iosHintText: string,
): void {
  try {
    if (localStorage.getItem(OFFERED_KEY) === '1') return;
    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      (navigator as unknown as { standalone?: boolean }).standalone === true;
    if (standalone) return;
    if (deferred) {
      localStorage.setItem(OFFERED_KEY, '1');
      const d = deferred;
      showToastFn(keepUsText, installLabel, () => void d.prompt());
    } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      localStorage.setItem(OFFERED_KEY, '1');
      showToastFn(iosHintText);
    }
  } catch {
    // storage failures never block play
  }
}
